module.exports = __webpack_public_path__ + "img/tesisler-img.cd368a0b.png";